import { BsCheck2 } from "react-icons/bs"
import { Button } from "reactstrap";

const ButtonNavigator = ({ flowAt, setFlowAt, options }) => {
  return (
    <div className="d-flex button-navigator-1">
      {options?.map((item, k) => (
        <Button
          className={item?.flowAt === flowAt ? "active" : ""}
          onClick={() => setFlowAt(item?.flowAt)}
        >
          {item?.flowAt === flowAt ? <BsCheck2 size={20} /> : null} {item?.title}
        </Button>
      ))}
    </div>
  );
};

export default ButtonNavigator;
